import React, { useEffect } from "react";
import AppProviders from "components/providers/AppProviders";
import {
  initializeServicesInBrowser,
  manipulateDomInBrowser,
} from "services/shared/next/NextAppLifecycle";
import "tailwindcss/tailwind.css";
import "stylesheets/Overrides.css";
import "stylesheets/NextImage.css";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "services/shared/redux/Store";
import { UserContextProvider } from "contexts/new/UserContext";
import { RoutingContextProvider } from "contexts/new/RoutingContext";
import { DefaultMetaTags } from "components/shared/MetaTags/MetaTags";
import type { AppProps } from "next/app";
import { ScriptTags } from "components/document/HeadTags";

function CustomApp({ Component, pageProps }: AppProps) {

  useEffect(() => {
    initializeServicesInBrowser();
    manipulateDomInBrowser();
  }, [])

  return (
    <ReduxProvider store={store}>
      <RoutingContextProvider>
        <AppProviders>
          <UserContextProvider>
            <DefaultMetaTags/>
            <ScriptTags/>
            <Component {...pageProps} />
          </UserContextProvider>
        </AppProviders>
      </RoutingContextProvider>
    </ReduxProvider>
  );
}

export default CustomApp;